import axiosIns from '@/libs/axios'
import {getUserData} from '@/auth/utils'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchCategories(ctx, queryParams){
      return new Promise((resolve, reject) => {
          axiosIns.get('/category/list', {params:queryParams})
          .then(response=>resolve(response))
          .catch(error=>reject(error))
      })
    },
    updateCategory(ctx, data) {
      return new Promise((resolve, reject) => {
          axiosIns.post('/category', data)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    deleteCategory(ctx, queryParams)
    {
      return new Promise((resolve, reject) => {
        axiosIns.delete('/category', {params:queryParams})
        .then(response=>resolve(response))
        .catch(error=>reject(error))
    })
    }
  },
}
